
    <div class="tooltip-container" [style.top]="top" [style.left]="left" [style.visibility]="visible">
      <ng-content></ng-content>
    </div>
  